import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';

import { DEFAULT_SECTION_KEYS } from '../constants';
import ExtraInfoCardSection from '../Section';

function Content({ sections = DEFAULT_SECTION_KEYS, messageKey, messageValues = {} }) {
  return (
    <Stack spacing={2}>
      {sections.map((sectionKey) => (
        <ExtraInfoCardSection
          key={sectionKey}
          messageKey={`${messageKey}.extraInfoSheet.${sectionKey}`}
          messageValues={messageValues}
        />
      ))}
    </Stack>
  );
}

Content.propTypes = {
  sections: PropTypes.array,
  messageKey: PropTypes.string.isRequired,
  messageValues: PropTypes.object
};

export default Content;
